import script from "./southDriver.vue?vue&type=script&setup=true&lang=js"
export * from "./southDriver.vue?vue&type=script&setup=true&lang=js"

import "./southDriver.vue?vue&type=style&index=0&id=37251fc7&lang=less"

const __exports__ = script;

export default __exports__